/**
 * Logger conditionnel pour l'application
 *
 * En production, seuls les erreurs sont loggées.
 * En développement, tous les logs sont affichés.
 *
 * Usage:
 * import { logger } from '../utils/logger';
 * logger.log('Message de debug');
 * logger.error('Erreur critique');
 * logger.warn('Avertissement');
 */

const isDevelopment = process.env.NODE_ENV !== 'production';

export const logger = {
  /**
   * Log générique - Affiché uniquement en développement
   */
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * Log d'information - Affiché uniquement en développement
   */
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  /**
   * Avertissement - Affiché uniquement en développement
   */
  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  /**
   * Erreur - Toujours affichée (dev ET prod)
   */
  error: (...args: any[]) => {
    console.error(...args);
  },

  /**
   * Debug - Affiché uniquement en développement
   * Utile pour les logs très verbeux
   */
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },

  /**
   * Table - Affiché uniquement en développement
   * Utile pour afficher des objets/arrays
   */
  table: (data: any) => {
    if (isDevelopment && console.table) {
      console.table(data);
    }
  },

  /**
   * Group - Affiché uniquement en développement
   * Utile pour grouper des logs
   */
  group: (label: string) => {
    if (isDevelopment && console.group) {
      console.group(label);
    }
  },

  /**
   * Group End - Affiché uniquement en développement
   */
  groupEnd: () => {
    if (isDevelopment && console.groupEnd) {
      console.groupEnd();
    }
  },

  /**
   * Time - Performance timing (développement uniquement)
   */
  time: (label: string) => {
    if (isDevelopment && console.time) {
      console.time(label);
    }
  },

  /**
   * Time End - Performance timing (développement uniquement)
   */
  timeEnd: (label: string) => {
    if (isDevelopment && console.timeEnd) {
      console.timeEnd(label);
    }
  },
};

export default logger;
